document.addEventListener( 'DOMContentLoaded', function () {

  function animateCounter( element, target, duration = 2000 ) {
    const start = 0;
    const startTime = performance.now();

    function update( currentTime ) {
      const elapsed = currentTime - startTime;
      const progress = Math.min( elapsed / duration, 1 );

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow( 1 - progress, 4 );
      element.textContent = Math.floor( start + (target - start) * easeOutQuart );

      if ( progress < 1 ) {
        requestAnimationFrame( update );
      } else {
        element.textContent = target;
      }
    }

    requestAnimationFrame( update );
  }

  const statsItems = document.querySelectorAll( '.stats__item-number' );

  if ( statsItems.length > 0 ) {
    const observerOptions = {
      threshold: 0.5,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver( ( entries ) => {
      entries.forEach( entry => {
        if ( entry.isIntersecting && !entry.target.dataset.animated ) {
          const targetValue = parseInt( entry.target.textContent, 10 );
          if ( !isNaN( targetValue ) ) {
            entry.target.dataset.animated = 'true';
            animateCounter( entry.target, targetValue, 2000 );
          }
        }
      } );
    }, observerOptions );

    statsItems.forEach( item => {
      observer.observe( item );
    } );
  }

} );
